import { render } from "./AddStaffMemberModal.vue?vue&type=template&id=2ad25202&scoped=true&ts=true"
import script from "./AddStaffMemberModal.vue?vue&type=script&lang=ts"
export * from "./AddStaffMemberModal.vue?vue&type=script&lang=ts"

import "./AddStaffMemberModal.vue?vue&type=style&index=0&id=2ad25202&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ad25202"]])

export default __exports__